export const convertToLocalTimezone = (dateString: string) => {
    // Parse the date string into a UTC Date object
    const utcDate = new Date(dateString + "T00:00:00Z");
  
    // Extract the year, month, and date from the UTC Date object
    const year = utcDate.getUTCFullYear();
    const month = utcDate.getUTCMonth(); // Month is zero-indexed
    const day = utcDate.getUTCDate();
  
    // Create a new Date object using the local timezone (this avoids the UTC conversion)
    const localDate = new Date(year, month, day);
  
    return localDate;
}

// nth = 1st, 2nd, 3rd, etc.
// dayOfWeek = 0 = Sunday, 1 = Monday, etc.
// month = 1 = January, 2 = February, etc.
export const getNthDayOfWeek = (nth: number,  dayOfWeek: number , month: number, year: number) => {
    // Create a date object for the first day of the month
    const date = new Date(year, month - 1, 1); // months are 0-indexed (0 = January)
    
    // Find the first occurrence of the dayOfWeek in the month
    const firstDay = date.getDay();
    const dayOffset = (dayOfWeek - firstDay + 7) % 7;
    
    // Set the date to the first occurrence of the desired weekday
    date.setDate(date.getDate() + dayOffset);
    
    // Add 7 days for each subsequent occurrence
    date.setDate(date.getDate() + (nth - 1) * 7);
    
    // Check if the nth occurrence is within the same month
    if (date.getMonth() !== month - 1) {
      return null; // Return null if the nth occurrence is out of the month
    }
  
    return date;
}

// weekday = 0 = Sunday, 1 = Monday, etc.
// month = 1 = January, 2 = February, etc.
export const getLastWeekdayOfMonth = (weekday: number, month: number, year: number) => {
    // Get the last day of the given month
    const lastDate = new Date(year, month, 0); // `0` gives us the last day of the previous month
    const lastDay = lastDate.getDay(); // Get the day of the week for the last day of the month
    
    // Calculate the offset to get the last occurrence of the desired weekday
    const dayOffset = (lastDay - weekday + 7) % 7;
    
    // Set the date to the last desired weekday
    lastDate.setDate(lastDate.getDate() - dayOffset);
    
    return lastDate;
}

export const getNextDay = (date: Date) => {
    // Create a new Date object based on the provided date
    const nextDay = new Date(date);
    
    // Increment the date by one day
    nextDay.setDate(nextDay.getDate() + 1);
    
    return nextDay;
}